// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

const bugsnag = require('bugsnag-js')
const bugsnagClient = bugsnag(BUGSNAG_TOKEN)

import Vue from 'vue'
import bugsnagVue from 'bugsnag-vue'

bugsnagClient.use(bugsnagVue(Vue))
bugsnagClient.releaseStage = BUGSNAG_ENV
bugsnagClient.appVersion = VERSION

import App from './App'
import router from './router'
import store from './stores/store.js'
import axios from 'axios'
import API from '@s/API'
import moment from 'moment'
import frLocale from 'moment/locale/fr';
import esLocale from 'moment/locale/es';
import itLocale from 'moment/locale/it';
import VueLocalStorage from 'vue-localstorage'
import VueI18n from 'vue-i18n'
import { i18n } from './setup/i18n-setup';
import traductions from '@/services/traductions.js'
import TransferDom from '@/directives/TransferDom.js'
import VeeValidate, { Validator } from 'vee-validate'
import fr from 'vee-validate/dist/locale/fr'
import GoogleAuth from 'vue-google-auth'

Vue.config.devtools = 'production' !== process.env.NODE_ENV
Vue.config.performance = true

import Utils from '@s/utils'

import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon, FontAwesomeLayers } from '@fortawesome/vue-fontawesome'

import { Can } from '@/directives/Can.js'
import VInputmask from 'v-inputmask'

import Btn from '@c/ui/Button'

import FleetIcon from '@a/img/universes/fleet.svg'
import ParkIcon from '@a/img/universes/park.svg'
import MissionIcon from '@a/img/universes/mission.svg'
import BeepizIcon from '@a/img/universes/beepiz.svg'
import CatsafeIcon from '@a/img/universes/catsafe-svg.vue'
import SfrdatiIcon from '@a/img/universes/sfrdati-svg.vue'
import BomIcon from '@a/img/universes/bom.svg'
import VisionIcon from '@a/img/universes/vision.svg'
import ApiIcon from '@a/img/universes/api.svg'
import AdminIcon from '@a/img/universes/admin.svg'

import GoogleIcon from '@a/img/google-logo-sso.svg'

Vue.config.productionTip = false

Vue.use(VueLocalStorage)
Vue.use(i18n)
Vue.use(Utils)
Vue.use(VInputmask)
Vue.use(GoogleAuth, { clientId: '394106092197-bj168i1dehtnjci33h0quti70im28822.apps.googleusercontent.com' })
Vue.googleAuth().load()
// Can pass en/fr/es/it as moment locale
moment.locale('fr', [
    frLocale,
    esLocale,
    itLocale
]);

Vue.use(VeeValidate, {
    locale: 'fr',
    dictionary: {
        fr: fr,
    },
    delay: 0,
    enableAutoClasses: true,
    events: '',
})
Validator.localize('fr', fr)

library.add(fas)

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('Btn', Btn)
Vue.component('FleetIcon', FleetIcon)
Vue.component('ParkIcon', ParkIcon)
Vue.component('MissionIcon', MissionIcon)
Vue.component('BeepizIcon', BeepizIcon)
Vue.component('CatsafeIcon', CatsafeIcon)
Vue.component('SfrdatiIcon', SfrdatiIcon)
Vue.component('BomIcon', BomIcon)
Vue.component('VisionIcon', VisionIcon)
Vue.component('ApiIcon', ApiIcon)
Vue.component('AdminIcon', AdminIcon)
Vue.component('GoogleIcon', GoogleIcon)

Vue.directive('can', Can)
Vue.directive('transferDom', TransferDom)

// Conditionnement de l'url API, SDF utilise API SDF, BPZ/SFR utilise API BPZ
API.apiBaseURL = window.location.host.includes('suivideflotte') ? API_BASE_SDF : API_BASE_BPZ;
API.apiAuthUrl = window.location.host.includes('suivideflotte') ? API_BASE_AUTH : API_BASE_AUTH_BEEPIZ;

axios.defaults.baseURL = API.apiBaseURL
axios.defaults.headers['X-Version'] = API.apiVersion
axios.defaults.headers.Accept = 'application/json'
axios.defaults.headers.app = 'admin-front'
// axios.defaults.headers.Authorization = 'Bearer ' + 'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImMxZTY1Mjc1MjVmNTI4NGFjZmYwZTViYzk1NzAyZTEwMjUyNjUwYWFmYWYwM2U3ZjhiMzk1MmYzOWJmOThlYjBjODE2ZTc5MWRhNTg1NTAxIn0.eyJhdWQiOiIxMDMiLCJqdGkiOiJjMWU2NTI3NTI1ZjUyODRhY2ZmMGU1YmM5NTcwMmUxMDI1MjY1MGFhZmFmMDNlN2Y4YjM5NTJmMzliZjk4ZWIwYzgxNmU3OTFkYTU4NTUwMSIsImlhdCI6MTY2NTM4NTc5NCwibmJmIjoxNjY1Mzg1Nzk0LCJleHAiOjE2NjU0NzIxOTMsInN1YiI6IjMzMTE5Iiwic2NvcGVzIjpbIioiXX0.ZKSC9J1N2271HAgLXOMSH1kd0d4PQpulHipUoVhkc70dTL_rMIznlA-2DdvYJ5sW_3Siut21-d3M1BzbA1mBSOIL2nUvxDF3QvOgB8Jkt9ANBNRJDqKZL-O-x3197wY8w50aSZ0mDXtDbBG08ztlxeDbq4oBGhAevz2sAA3lHyU4d3kmyfo6NPwV47wywY7kUhWhObnFJf9sN6eu9i0gW9KiqyLhrSuuTYm6kPlUzN8B6qicRu4oKtK3pvOsOugkEbaTTY0LJnZ6SRQooxBSv-y98r5lkskfr4326GSZBnIA-fPAnaLC1TRLVuVraTds0ibY-_7PNnh_oRWwJM9VP1t4tlapfn6Z6XNVD9znUm-0OPupvWhit2dEPdKjXVEdkk-paz6BIMRh3qsva8HfA11G49ytKZG-DuFtaDvckjBzVHwoOCfD3OpQS2BvbD27nXb4SpVEJOAwSKUATSsXinpMrF4-sGM8gYjQAvqj84FM4S-IK278tHQmNQucgMt-oSJF49k4jBlw4LkXR6tyqPEwIdVclKPlzgCgY5gRVyO6I1m90dyVkkKKRurbYurVOXHV06Cki8hk1WLGNDFSP363JolO6Z_5QpyslYF0mtmFatEscG5wml5utPwN0PE-Bvr4LgVMzCkWUOMn6E95_gz641O3KnUpVHYyshRABGg'

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    i18n,
    store,
    components: {
        App,
    },
    template: '<App/>',
    created() {
        window.V = this
    },
})

Vue.filter('date', function (value, arg) {
    if (null != value) {
        if ('string' == typeof value) {
            return moment(value).format(arg)
        }
        if ('object' == typeof value) {
            return moment(value.date).tz(value.timezone).format(arg)
        }
    }
    return ''
})

Vue.filter('arrayToString', function (value) {
    if (null != value) {
        console.log(typeof value)
        if ('object' == typeof value) {
            console.log(value, value.join(', '))

            let val = ''

            if (value.length > 1) {
                val = value.slice(0, value.length - 1).join(', ') + ' et ' + value[value.length - 1]
            } else {
                val = value.join(', ')
            }

            return val
        }
    }

    return ''
})

//SERVICE WORKER
;(function () {
    if ('serviceWorker' in navigator) {
        navigator.serviceWorker.register('/sw.js')
    }
})()



// WEBPACK FOOTER //
// ./src/main.js